import { createContext, useContext, useState } from 'react';
import { useGate } from 'statsig-react';

export const TestConsoleContext = createContext({
  darkModeAvailable: false,
  useDarkMode: false,
  setUseDarkMode: (useDarkMode: boolean) => {},
});

export const TestConsoleProvider = ({ children }: { children: React.ReactNode }) => {
  const allowLinkDarkModeGate = useGate('ff-allow-link-dark-mode');
  const linkOrigamiThemeNextGate = useGate('ff-link-origami-theme-next');

  const [useDarkMode, setUseDarkMode] = useState(false);

  const handleSetUseDarkMode = (useDarkMode: boolean) => {
    if (!linkOrigamiThemeNextGate.value || !allowLinkDarkModeGate.value) return;
    setUseDarkMode(useDarkMode);
  };

  return (
    <TestConsoleContext.Provider
      value={{
        darkModeAvailable: linkOrigamiThemeNextGate.value && allowLinkDarkModeGate.value,
        useDarkMode,
        setUseDarkMode: handleSetUseDarkMode,
      }}
    >
      {children}
    </TestConsoleContext.Provider>
  );
};

export const useTestConsole = () => {
  const context = useContext(TestConsoleContext);
  if (!context) {
    throw new Error('useTestConsole must be used within a TestConsoleProvider');
  }
  return context;
};
